export class OrganizationStudentUpdateModal {
	success: boolean;
	uid?: number;
	error_messages?: string[];
}
